import React, { useState } from 'react';
import { faBug, faPaperPlane, faTimes } from '@fortawesome/free-solid-svg-icons';
import { gql, useMutation } from '@apollo/client';

import { Button } from 'react-bulma-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from '../styles';
import { useAuth } from 'react-oidc-context';
import { useGlobalState } from '../state';

const REPORT_BUG = gql`
  mutation ReportBug($title: String!, $description: String!, $page: String!, $context: String) {
    reportBug(title: $title, description: $description, page: $page, context: $context)
  }
`;

const formatPageContext = (ctx) => {
  if (!ctx) return null;
  const kind = ctx.type === 'fact' ? 'Fact' : 'Song';
  return `${kind}: ${ctx.title} (${ctx.slug}) — step ${ctx.step} of ${ctx.totalSteps}`;
};

const BugReportButton = () => {
  const auth = useAuth();
  const [pageContext] = useGlobalState('pageContext');
  const [reportBug, { loading }] = useMutation(REPORT_BUG);
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [submitted, setSubmitted] = useState(false);

  if (!auth.isAuthenticated) return null;

  const close = () => {
    setOpen(false);
    setSubmitted(false);
    setTitle('');
    setDescription('');
  };

  const submit = async () => {
    if (!title.trim() || !description.trim()) return;
    await reportBug({
      variables: {
        title,
        description,
        page: window.location.pathname,
        context: formatPageContext(pageContext),
      },
    });
    setSubmitted(true);
  };

  return (
    <>
      <Button
        color="danger"
        rounded
        title="Report a bug"
        onClick={() => setOpen(true)}
        style={{
          position: 'fixed',
          bottom: '1.5rem',
          right: '1.5rem',
          width: '3rem',
          height: '3rem',
          zIndex: 1000,
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        }}
      >
        <FontAwesomeIcon icon={faBug} size="lg" />
      </Button>

      {open && (
        <>
          <div
            onClick={close}
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0,0,0,0.4)',
              zIndex: 1001,
            }}
          />
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              bottom: 0,
              width: '360px',
              maxWidth: '90vw',
              background: 'white',
              zIndex: 1002,
              boxShadow: '-2px 0 12px rgba(0,0,0,0.2)',
              padding: '1.5rem',
              overflowY: 'auto',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
              <h3 style={{ margin: 0, fontWeight: 'bold', fontSize: '1.25rem' }}>Report a bug</h3>
              <span style={{ cursor: 'pointer' }} onClick={close}>
                <FontAwesomeIcon icon={faTimes} />
              </span>
            </div>

            {submitted ? (
              <div>
                <p>Thanks — your report has been sent!</p>
                <Button color="light" fullwidth style={{ marginTop: '1rem' }} onClick={close}>
                  Close
                </Button>
              </div>
            ) : (
              <>
                <div className="field">
                  <label className="label">Title</label>
                  <div className="control">
                    <input
                      className="input"
                      type="text"
                      placeholder="Short summary of the problem"
                      value={title}
                      onChange={evt => setTitle(evt.target.value)}
                    />
                  </div>
                </div>
                <div className="field">
                  <label className="label">Description</label>
                  <div className="control">
                    <textarea
                      className="textarea"
                      rows={6}
                      placeholder="What happened? What did you expect instead?"
                      value={description}
                      onChange={evt => setDescription(evt.target.value)}
                    />
                  </div>
                </div>
                <p style={{ color: colors.textSecondary, fontSize: '0.8rem' }}>
                  Your account, the current page{pageContext ? ' and step' : ','} will be included automatically.
                </p>
                <Button
                  color="danger"
                  fullwidth
                  loading={loading}
                  disabled={!title.trim() || !description.trim()}
                  onClick={submit}
                  style={{ marginTop: '1rem' }}
                >
                  <FontAwesomeIcon icon={faPaperPlane} />&nbsp;Send report
                </Button>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default BugReportButton;
